



































































































































































































































































































import { Action, State } from 'vuex-class';
import { cloneDeep } from 'lodash';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import UserMixin from '@/mixins/UserMixin';
import CustomSelect from '@/components/FormBuilder/CustomSelect.vue';
import FileLoader from '@/components/FileLoader.vue';
import FormFactoryModal from '@/components/Entity/FormFactoryModal.vue';
import DateRange from '@/components/common/DateRange.vue';
import { getPreviousFullMonthRange } from '@/utils/previousMonthRange';
import ContractParagraphsField from '@/components/Pretensions/ContractParagraphsField.vue';
import LoadingDataMixin from '@/mixins/LoadingDataMixin';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import { PlatformType, CostCentersType } from '@/store/directory/types';
import {
  Mixins,
  Component,
  Watch,
} from 'vue-property-decorator';
import {
  AccountingSheet, Attachment, CreatePretensionData, PretensionDraftPayload, SaveDraftData, Draft,
} from '@/controllers/types';
import PretensionController from '@/controllers/Pretension';
import AccountingSheetController from '@/controllers/AccountingSheet';
import { parseDateIso } from '@/utils/operationReportDisplay';
import {
  AMOUNT_FORMAT_ERROR, AMOUNT_HINT, amountFormat, normalizeAmountSeparator, parseAmount,
} from '@/utils/amountInput';
import {
  DUPLICATE_CLIENT_COST_CENTER_ERROR,
  duplicateCashAccountPairsMessage,
  duplicateCashAccountRowIndexes,
  noDuplicateClientCostCenter,
} from '@/utils/cashAccountDuplicates';
import { openLoadingTab, showTabError } from '@/utils/previewTab';
import { EventEmitter } from 'events';
import { describeOperationError } from '@/utils/extractApiErrorMessage';
import formatMb from '@/utils/formatMb';
import { AccountingSheetInterface } from '@/types/AccountingSheet';
import { PretensionPrefill, sheetRowError } from '@/utils/sheetPretensions';

type FormData = PretensionDraftPayload;

// Лимит «Краткого описания причины ущерба» — единый источник для maxlength/counter/валидации.
const DAMAGE_DESCRIPTION_MAX = 500;

// Лимиты подписи в Диадоке (как в diadoc-api): файл — полка одним куском, пакет — тело запроса в base64.
const DIADOC_MAX_FILE_BYTES = 3 * 1024 * 1024;
const DIADOC_MAX_TOTAL_BYTES = 7 * 1024 * 1024;

@Component({
  components: {
    CustomSelect,
    FormFactoryModal,
    DateRange,
    ContractParagraphsField,
    FileLoader,
  },
})
export default class CreatePretension extends Mixins(UserMixin, EntityHelperMixin, validationMixin, LoadingDataMixin) {
  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @State('platforms', { namespace: 'directory' })
  readonly platforms!: PlatformType[];

  @State('platformsIsLoading', { namespace: 'directory' })
  readonly platformsIsLoading!: boolean;

  uploadFiles = new EventEmitter();

  uploadFilesDone = true;

  clients = [];

  clientsIsLoading = false;

  suppliers = [];

  suppliersIsLoading = false;

  isSendingCreatingRequest = false;

  mode: 'create' | 'edit' = 'create';

  draftId: number | null = null;

  draftUpdatedAt: string | null = null;

  // Email автора открытого черновика — для предупреждения при удалении чужого черновика.
  draftCreatedByEmail: string | null = null;

  // Номер претензии, возвращённой на доработку; у нового черновика — null.
  draftNumber: string | null = null;

  isSavingDraft = false;

  isDeletingDraft = false;

  isPreviewLoading = false;

  isPreviewError = false;

  initialAttachments: Attachment[] = [];

  // Подавляет сброс supplier/clients вотчером platform во время гидрации черновика (edit).
  isHydratingDraft = false;

  // Период, пришедший из карточки листа: поле дат показывает его, не трогая фильтр страницы.
  prefillPeriod: string[] | null = null;

  // Листы, загруженные по ID строки листа: null — такого листа нет. Сбой запроса не кэшируем.
  loadedSheets: Record<string, AccountingSheetInterface | null> = {};

  // Запрос листа в пути: потеря фокуса и отправка формы ждут один и тот же ответ.
  sheetRequests: Record<string, Promise<AccountingSheetInterface | null> | undefined> = {};

  @State('costCenters', { namespace: 'directory' })
  readonly costCenters!: CostCentersType[];

  @State('costCentersIsLoading', { namespace: 'directory' })
  readonly costCentersIsLoading!: boolean;

  types = ['fine', 'damage'];

  descriptionMaxLength = DAMAGE_DESCRIPTION_MAX;

  amountHint = AMOUNT_HINT;

  defaultFormData: FormData = {
    type: '',
    date: null,
    supplier: null,
    platform: null,
    text: '',
    attachments: [],
    cashAccounts: [
      {
        client: null,
        costCenter: null,
        amount: null,
      },
    ],
    accountingSheets: [
      {
        sheetId: null,
        number: null,
        period: null,
        amount: null,
      },
    ],
    // CP-S1: пустой массив, НЕ [{number:null}] — пустой item ломал бы $each-валидацию чипсов.
    contractParagraphs: [],
    // Объявляем ns ключом дефолта → reactive из инициализации (Vue 2): иначе присваивание
    // formData.ns = ... не триггерит computed attachmentsKeyPrefix. Реальный ns ставит
    // resetToCreate (create) или applyDraftEnvelope (reopen) до любого сохранения.
    ns: '',
  }

  formData: FormData = cloneDeep(this.defaultFormData);

  selectedFileNames: string[] = [];

  // Постфикс центра затрат (после последнего '_') соответствует имени платформы
  // (напр. HAN_HMK / COC_HMK ↔ платформа HMK).
  private costCenterMatchesPlatform(cc: CostCentersType, platformName: string): boolean {
    const parts = (cc?.name ?? '').split('_');
    return parts[parts.length - 1] === platformName;
  }

  // При выбранной платформе центры с её постфиксом поднимаем НАВЕРХ списка (остальные — ниже,
  // исходным порядком). Автоподстановку НЕ делаем (на постфикс несколько центров — неоднозначно).
  get sortedCostCenters(): CostCentersType[] {
    const platformName = this.formData.platform?.name;
    if (!platformName) return this.costCenters;
    const matching = this.costCenters.filter((cc) => this.costCenterMatchesPlatform(cc, platformName));
    const rest = this.costCenters.filter((cc) => !this.costCenterMatchesPlatform(cc, platformName));
    return [...matching, ...rest];
  }

  // id'шники центров с постфиксом выбранной платформы — рендерятся жирным в дропдауне.
  get matchingCostCenterIds(): Array<string | number> {
    const platformName = this.formData.platform?.name;
    if (!platformName) return [];
    return this.costCenters
      .filter((cc) => this.costCenterMatchesPlatform(cc, platformName))
      .map((cc) => cc.id);
  }

  get hasSelectedFiles(): boolean {
    return this.selectedFileNames.length > 0;
  }

  // PDF-only для ВСЕХ типов претензии (и до выбора типа) — единое правило вложений.
  get acceptedFileTypes(): string {
    return 'application/pdf';
  }

  // Лейбл кнопки прикрепления — единый для всех типов: только PDF и лимиты подписи в Диадоке.
  get attachButtonLabel(): string {
    return 'Прикрепить файлы (только PDF, до 3 МБ, вместе до 7 МБ)';
  }

  get maxFileBytes(): number {
    return DIADOC_MAX_FILE_BYTES;
  }

  get maxTotalBytes(): number {
    return DIADOC_MAX_TOTAL_BYTES;
  }

  // Блок отправки для вложений тяжелее лимитов подписи. Новые файлы FileLoader не пропускает на
  // добавлении — сюда попадают лежащие в старых черновиках (size отдаёт GetDraft из S3).
  // Пустая строка — отправлять можно.
  get oversizeAttachmentsMessage(): string {
    const attachments = this.formData.attachments || [];
    const total = attachments.reduce((sum, a) => sum + (a.size || 0), 0);
    const heavy = attachments.filter((a) => (a.size || 0) > DIADOC_MAX_FILE_BYTES);
    if (heavy.length === 0 && total <= DIADOC_MAX_TOTAL_BYTES) {
      return '';
    }
    const files = heavy
      .map((a) => `«${a.objectName.split('/').pop()}» — ${formatMb(a.size as number)} ${this.$t('mb')}, `)
      .join('');
    return this.$t('pretension_oversize_blocked', { files, total: formatMb(total) }) as string;
  }

  // Блок отправки при не-PDF вложении для ЛЮБОГО типа. Дублирует add-time гейт FileLoader
  // осознанно: ловит гидрированные из старых черновиков не-PDF файлы, которые на добавлении
  // не проходили через processFiles.
  get hasNonPdfAttachment(): boolean {
    return this.selectedFileNames.some((name) => !/\.pdf$/i.test(name));
  }

  get isEdit(): boolean {
    return this.mode === 'edit';
  }

  get canSaveDraft(): boolean {
    return !!this.formData.platform && !!this.formData.supplier && !!this.formData.type;
  }

  @Validations()
  validations = {
    formData: {
      type: {
        required,
      },
      date: {
        required,
        // Листы учёта формируются только за прошлые месяцы: текущий месяц и будущее — ошибка ввода.
        pastMonths: (value: string[] | null) => !value || value.length !== 2
          || value[1] <= getPreviousFullMonthRange()[1],
      },
      supplier: {
        required,
      },
      platform: {
        required,
      },
      // Описание ущерба не обязательно, но ограничено по длине (только фронт). Лимит применяем
      // ТОЛЬКО к type=damage: для штрафа поле описания не используется, и оставшийся от
      // переключения/легаси-черновика длинный текст не должен блокировать «Отправить» скрытым
      // полем. Ключ validator'а оставлен maxLength — на него завязан getValidationErrors.
      text: {
        maxLength: (value: string, parent: { type?: string }) => parent?.type !== 'damage'
          || maxLength(DAMAGE_DESCRIPTION_MAX)(value),
      },
      cashAccounts: {
        // Дубль пары (клиент, центр затрат) роняет сборку на уникальном индексе pretension_client
        // — держим $v.$invalid, через который закрыты предпросмотр и отправка. Конкретику
        // (какая пара задвоена) даёт отдельный тост: общего текста тут недостаточно.
        noDuplicateClientCostCenter,
        $each: {
          client: {
            required,
          },
          costCenter: {
            required,
          },
          amount: {
            required,
            amountFormat,
          },
        },
      },
      // Строк листа может не быть: поставщик платит претензию напрямую, без взаимозачёта
      // (встреча 16.09). Оставленная строка без ID — ошибка.
      accountingSheets: {
        // Проверять нечего, кроме ID листа: номер, период и сумма приходят из самого листа
        // и в тело запроса не идут (10833). Чужой, закрытый или несуществующий лист ловит
        // sheetIdErrors, а следом — сервис претензий.
        $each: {
          sheetId: { required },
        },
      },
      contractParagraphs: {
        required,
        minLength: minLength(1),
        $each: {
          number: {
            required,
            maxLength: maxLength(64),
          },
        },
      },
    },
  }

  @Action('toggleEntityModal', { namespace: 'entity' })
  readonly toggleEntityModal: any;

  showModal() {
    this.resetToCreate();
    this.setPeriod(getPreviousFullMonthRange());
    this.toggleEntityModal(true);
  }

  /** Период претензии: поле показывает его и отдаёт в форму. */
  private setPeriod(range: string[]): void {
    this.prefillPeriod = [...range];
    this.formData.date = [...range];
  }

  /** Есть лист — период претензии берётся из листа и руками не меняется. */
  get periodLockedBySheet(): boolean {
    return this.formData.accountingSheets.some((row) => !!row.period);
  }

  get dateErrors(): string[] {
    const v = this.$v.formData.date as any;
    if (!v || !v.$error) {
      return [];
    }
    if (v.required === false) {
      return ['Обязательное поле'];
    }
    return v.pastMonths === false ? ['Период — не позже конца прошлого месяца'] : [];
  }

  closeModal() {
    this.toggleEntityModal(false);
  }

  resetToCreate(): void {
    this.mode = 'create';
    this.draftId = null;
    this.draftUpdatedAt = null;
    this.draftCreatedByEmail = null;
    this.draftNumber = null;
    this.initialAttachments = [];
    // Свежий неймспейс на каждую create-сессию: попадёт в draft_payload через buildSaveDraftData.
    this.formData.ns = this.generateNs();
  }

  // Короткий (8 hex) клиентский неймспейс черновика. Бюджет object_name = varchar(100):
  // attachments/<ns>/<имя> = 21 + длина имени. crypto.getRandomValues работает и на http
  // (не требует secure context, в отличие от subtle); Math.random — fallback.
  private generateNs(): string {
    try {
      const arr = new Uint8Array(4);
      (window.crypto || ({} as any)).getRandomValues(arr);
      return Array.from(arr).map((b) => b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
      return Math.floor(Math.random() * 0xffffffff).toString(16).padStart(8, '0');
    }
  }

  // Префикс ключа вложений претензии: attachments/<ns>/. Передаётся в FileLoader.
  get attachmentsKeyPrefix(): string {
    return this.formData.ns ? `attachments/${this.formData.ns}/` : '';
  }

  get currentUserEmail(): string {
    return this.pimcoreUser?.email || '';
  }

  // Чужой черновик: автор и текущий пользователь оба известны и различаются. Сравнение
  // регистронезависимое; при пустой сессии (currentUserEmail === '') не считаем чужим, чтобы
  // не показывать ложное предупреждение «коллеги».
  get isColleagueDraft(): boolean {
    const author = (this.draftCreatedByEmail || '').toLowerCase();
    const me = this.currentUserEmail.toLowerCase();
    return !!author && !!me && author !== me;
  }

  // Конфликт версий черновика (HTTP 409): предупредить и перезагрузить. Общий для onSaveDraft
  // и submitCreate (edit-ветка) — единый текст и поведение.
  private async handleDraftConflict(id: number): Promise<void> {
    this.$bus.$emit('notification', 'Запись была изменена коллегой, черновик перезагружен', 'warning');
    await this.refetchDraft(id);
  }

  // Валиден ли envelope ответа draft-операции: create → {id:number}, update → {updatedAt:string}.
  // Защищает от мисроута (SPA HTML вместо JSON) — truthy-строка не пройдёт как успех.
  private isValidDraftEnvelope(error: unknown, result: unknown, mode: 'create' | 'update'): boolean {
    if (error || !result || typeof result !== 'object') return false;
    const r = result as { id?: unknown; updatedAt?: unknown };
    return mode === 'update' ? typeof r.updatedAt === 'string' : typeof r.id === 'number';
  }

  /**
   * Открыть черновик на редактирование. Идём через getDraft за СВЕЖИМ updatedAt (источник
   * If-Match — ответ Get/Save/Update, не строка списка) и draftPayload для гидрации.
   */
  async openForEdit(id: number): Promise<void> {
    const resp = await PretensionController.getDraft(id);
    const [error, draft] = resp.result;
    // 404: строка списка устарела — черновик уже отправили (в другой вкладке) или удалили.
    if (resp.code === 404) {
      this.$bus.$emit('notification', 'Черновик уже отправлен или удалён — список обновлён', 'warning');
      this.$emit('drafts-changed');
      return;
    }
    if (error || !draft) {
      this.$bus.$emit('notification', `Не удалось открыть черновик - ${error}`, 'error');
      return;
    }
    this.applyDraftEnvelope(draft as Draft);
    this.toggleEntityModal(true);
  }

  private applyDraftEnvelope(draft: Draft): void {
    const payload = draft.draftPayload || ({} as Draft['draftPayload']);
    this.isHydratingDraft = true;
    try {
      this.mode = 'edit';
      this.draftId = draft.id;
      this.draftUpdatedAt = draft.updatedAt;
      this.draftCreatedByEmail = draft.createdByEmail;
      this.draftNumber = draft.number ?? null;
      this.formData = cloneDeep({ ...this.defaultFormData, ...payload });
      this.setPeriod(payload.date && payload.date.length === 2 ? payload.date : getPreviousFullMonthRange());
      // Черновик несёт только id листа; остальные ключи строки нужны реактивными до того,
      // как их заполнит загруженный лист. У строк старых черновиков нет и sheetId.
      this.formData.accountingSheets = (this.formData.accountingSheets || [])
        .map((row) => ({ ...cloneDeep(this.defaultFormData.accountingSheets[0]), ...row }));
      this.loadSheetsOfRows();
      // Легаси-черновик без ns → выдаём новый, чтобы НОВЫЕ вложения неймспейсились (существующие
      // гидрированные сохраняют свой полный objectName и не перезаливаются).
      if (!this.formData.ns) {
        this.formData.ns = this.generateNs();
      }
      // Feed already-uploaded attachments into FileLoader so they are visible, deletable and
      // extendable in edit-mode. Fresh array ref → FileLoader's initialFiles watcher fires.
      this.initialAttachments = cloneDeep(payload.attachments || []);
      this.selectedFileNames = (payload.attachments || []).map((a) => a.objectName);
      this.uploadFilesDone = true;
      this.$v.$reset();
    } finally {
      // Снять флаг после flush вотчера formData.platform (он бежит раньше nextTick-колбэка).
      // finally — чтобы флаг не залип в true, если что-то выше бросит (иначе platform-вотчер
      // навсегда перестал бы сбрасывать supplier).
      this.$nextTick(() => { this.isHydratingDraft = false; });
    }
  }

  private buildSaveDraftData(): SaveDraftData {
    return {
      ...cloneDeep(this.formData),
      // Черновик хранит только id листов: номер, период и сумму при открытии подтянет сам лист,
      // поэтому старые цифры не показываются, если лист успели пересчитать (10833).
      accountingSheets: this.formData.accountingSheets.map((s) => ({ sheetId: s.sheetId ?? null })),
      platformId: this.formData.platform?.id ?? null,
      supplierId: this.formData.supplier?.id ?? null,
      dateFrom: this.formData.date ? this.formData.date[0] : null,
      dateTo: this.formData.date ? this.formData.date[1] : null,
    };
  }

  filesChanged(files: Array<any>, uploadDone = false) {
    this.formData.attachments = files.map((v: any) => ({
      bucket: v.bucket,
      objectName: v.filename,
      type: 'attachment',
      // hash живёт только в draft_payload (дедуп гидрированных); prepareBody его вычищает.
      hash: v.hash ?? null,
      size: v.size ?? null,
    }));
    this.uploadFilesDone = uploadDone;
  }

  onFilesSelected(fileNames: string[]) {
    this.selectedFileNames = fileNames;
  }

  addCashAccount() {
    this.formData.cashAccounts.push(cloneDeep(this.defaultFormData.cashAccounts[0]));
  }

  removeCashAccount(index: number) {
    this.formData.cashAccounts.splice(index, 1);
  }

  addAccountingSheet() {
    this.formData.accountingSheets.push(cloneDeep(this.defaultFormData.accountingSheets[0]));
  }

  removeAccountingSheet(index: number) {
    this.formData.accountingSheets.splice(index, 1);
  }

  periodText(period: string[] | null): string {
    return period && period.length === 2 ? `${period[0]} - ${period[1]}` : '';
  }

  /**
   * ID листа введён (Enter или потеря фокуса после правки): строка берёт номер, период и сумму
   * из листа. Старые значения строки остаются, если лист не нашёлся, — ошибку покажет поле.
   */
  async onSheetIdEntered(index: number): Promise<void> {
    const row = this.formData.accountingSheets[index];
    const id = String(row?.sheetId ?? '').trim();
    if (!/^\d+$/.test(id) || Number(id) <= 0) {
      return;
    }
    const sheet = await this.loadSheet(id);
    // Пока шёл запрос, строку могли удалить или вписать в неё другой ID.
    if (!sheet || this.formData.accountingSheets[index] !== row || String(row.sheetId ?? '').trim() !== id) {
      return;
    }
    this.applySheetToRow(row, sheet);
  }

  /**
   * Строка показывает то же, что уйдёт в документ: номер, период и сумму листа. В теле
   * запроса их нет — сервис претензий читает лист сам (10833), здесь они только для глаз.
   */
  private applySheetToRow(row: AccountingSheet, sheet: AccountingSheetInterface): void {
    // Номер листа не уникален по поставщику и площадке — впереди ID листа, как в имени
    // файла листа: «4241_НМК_45595» (уточнение заказчика 24.07.2026).
    row.number = sheet.number ? `${sheet.id}_${sheet.number}` : String(sheet.id);
    row.period = [parseDateIso(sheet.startDate), parseDateIso(sheet.finishDate)];
    row.amount = sheet.totalWithoutTax;
    this.setPeriod(row.period);
  }

  private loadSheet(id: string): Promise<AccountingSheetInterface | null> {
    if (this.loadedSheets[id] !== undefined) {
      return Promise.resolve(this.loadedSheets[id]);
    }
    const inFlight = this.sheetRequests[id] || this.fetchSheet(id);
    this.sheetRequests[id] = inFlight;
    return inFlight;
  }

  private async fetchSheet(id: string): Promise<AccountingSheetInterface | null> {
    try {
      const response = await AccountingSheetController.loadSingle(Number(id));
      const [error, result] = response.result;
      // Лист лежит в result.data, а не в result.
      const sheet = result?.data;
      if (!error && sheet && String(sheet.id) === id) {
        this.$set(this.loadedSheets, id, sheet);
        return sheet;
      }
      if (response.code === 404) {
        this.$set(this.loadedSheets, id, null);
        return null;
      }
      this.$bus.$emit('notification', `Не удалось загрузить лист учёта ${id} - ${error || 'неожиданный ответ сервера'}`, 'error');
    } catch (e) {
      this.$bus.$emit('notification', `Не удалось загрузить лист учёта ${id} - ${e}`, 'error');
    } finally {
      this.sheetRequests[id] = undefined;
    }
    return null;
  }

  /**
   * Загрузить листы всех строк и заполнить строки их данными: перед отправкой и после
   * открытия черновика (в черновике лежат только id листов).
   */
  private async loadSheetsOfRows(): Promise<void> {
    await Promise.all(this.formData.accountingSheets.map(async (row) => {
      const id = String(row.sheetId ?? '').trim();
      if (!/^\d+$/.test(id) || Number(id) <= 0) {
        return;
      }
      const sheet = await this.loadSheet(id);
      // Пока шёл запрос, в строку могли вписать другой ID.
      if (sheet && String(row.sheetId ?? '').trim() === id) {
        this.applySheetToRow(row, sheet);
      }
    }));
  }

  private sheetRowErrorAt(index: number): string | null {
    const rows = this.formData.accountingSheets;
    const sheet = this.loadedSheets[String(rows[index]?.sheetId ?? '').trim()];
    const owner = sheet
      ? { platformId: sheet.platformId ?? null, supplierId: sheet.supplierId ?? null, status: sheet.status ?? null }
      : sheet;
    const error = sheetRowError(
      rows, index, owner, this.formData.platform?.id, this.formData.supplier?.id, !!this.draftNumber,
    );
    const period = rows[index]?.period;
    const date = this.formData.date;
    // Период претензии идёт из листа — не совпасть он может только с другим листом претензии.
    if (!error && period && date && (period[0] !== date[0] || period[1] !== date[1])) {
      return 'Период листа не совпадает с периодом претензии';
    }
    return error;
  }

  get hasSheetRowErrors(): boolean {
    return this.formData.accountingSheets.some((_row, index) => this.sheetRowErrorAt(index) !== null);
  }

  /**
   * Лист не найден, чужой или повторён — видно сразу после загрузки листа. Пустой ID — после
   * попытки отправки или у старой строки, которую не свели с листом (решение 15 плана).
   */
  sheetIdErrors(index: number): string[] {
    const error = this.sheetRowErrorAt(index);
    if (!error) {
      return [];
    }
    const row = this.formData.accountingSheets[index];
    const blank = String(row.sheetId ?? '').trim() === '';
    if (blank && !row.number && !(this.$v.formData.accountingSheets as any).$dirty) {
      return [];
    }
    return [error];
  }

  /**
   * Форма из карточки листа (решение 13 плана): площадка → поставщики площадки → поставщик →
   * период → строка листа. Значение, которого нет в справочнике, пропускаем с уведомлением.
   */
  async openWithPrefill(prefill: PretensionPrefill): Promise<void> {
    this.showModal();
    await this.$nextTick();
    if (prefill.platformId) {
      await this.waitForPlatforms();
      const platform = this.platforms.find((item) => String(item.id) === prefill.platformId);
      if (platform) {
        // Тот же объект, что кладёт выпадающий список: по нему список показывает выбранную площадку.
        this.formData.platform = platform as unknown as FormData['platform'];
        // Вотчер площадки сбрасывает поставщика — выбираем его только после вотчера.
        await this.$nextTick();
        if (prefill.supplierId) {
          await this.loadDataByLike('suppliers', 'Supplier', 'PlantsHR', platform.id, 'cache-first', { maxDepth: 1 });
          const supplier = (this.suppliers as Array<{ id: string | number }>)
            .find((item) => String(item.id) === prefill.supplierId);
          if (supplier) {
            this.formData.supplier = supplier;
          } else {
            this.$bus.$emit('notification', 'Поставщик листа не найден на площадке — выберите его вручную', 'warning');
          }
        }
      } else {
        this.$bus.$emit('notification', 'Площадка листа не найдена — выберите её вручную', 'warning');
      }
    }
    if (prefill.period) {
      this.setPeriod(prefill.period);
      await this.$nextTick();
    }
    if (prefill.sheetId) {
      if (!this.formData.accountingSheets.length) {
        this.addAccountingSheet();
      }
      this.formData.accountingSheets[0].sheetId = String(prefill.sheetId);
      await this.onSheetIdEntered(0);
    }
  }

  private waitForPlatforms(): Promise<void> {
    if (!this.platformsIsLoading) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      const unwatch = this.$watch('platformsIsLoading', (loading: boolean) => {
        if (!loading) {
          unwatch();
          resolve();
        }
      });
    });
  }

  // CP-S1: свои сообщения (общий getValidationErrors хардкодит текст maxLength под 500).
  get contractParagraphsErrors(): string[] {
    const v = this.$v.formData.contractParagraphs as any;
    if (!v || !v.$error) return [];
    const errors: string[] = [];
    if (v.required === false || v.minLength === false) {
      errors.push('Обязательное поле');
    }
    const each = v.$each || {};
    const hasTooLong = Object.keys(each)
      .filter((k) => /^\d+$/.test(k))
      .some((k) => each[k]?.number?.maxLength === false);
    if (hasTooLong) {
      errors.push('Не более 64 символов');
    }
    return errors;
  }

  // Индексы строк, задвоенных по паре (клиент, центр затрат) — подсветка конкретных строк.
  get duplicateCashAccountIndexes(): number[] {
    return duplicateCashAccountRowIndexes(this.formData.cashAccounts);
  }

  // Свои сообщения поля «Центр затрат»: общий getValidationErrors видит только валидаторы самой
  // строки, а дубль — свойство пары строк (валидатор живёт на уровне массива cashAccounts).
  cashAccountCostCenterErrors(index: number): string[] {
    const v = this.$v.formData.cashAccounts as any;
    const errors = this.getValidationErrors(v.$each[index].costCenter);
    if (v.$dirty && this.duplicateCashAccountIndexes.includes(index)) {
      errors.push(DUPLICATE_CLIENT_COST_CENTER_ERROR);
    }
    return errors;
  }

  // Общий гейт дубля пары для черновика и отправки: тост называет задвоенные пары поимённо
  // (общее «Не все поля заполнены корректно» проблему не объясняет) и подсвечивает строки.
  // Возвращает false, если сохранять/отправлять нельзя.
  private ensureNoDuplicateCashAccounts(): boolean {
    const message = duplicateCashAccountPairsMessage(this.formData.cashAccounts);
    if (!message) return true;
    (this.$v.formData.cashAccounts as any).$touch();
    this.$bus.$emit('notification', message, 'error');
    return false;
  }

  getValidationErrors(validations: any): string[] {
    const errors: string[] = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    if (validations.maxLength === false) {
      errors.push(`Не более ${DAMAGE_DESCRIPTION_MAX} символов`);
    }
    if (validations.amountFormat === false) {
      errors.push(AMOUNT_FORMAT_ERROR);
    }
    return errors;
  }

  // Разделитель приводим к точке прямо в поле (change = blur/Enter, а не каждое нажатие —
  // иначе прыгает каретка): пользователь видит ровно то значение, которое уйдёт на бэк.
  // prepareBody нормализует повторно — страховка для легаси-черновиков с запятой.
  onAmountChange(value: string): string {
    return normalizeAmountSeparator(value);
  }

  async confirmDamageWithoutFiles(): Promise<boolean> {
    if (this.formData.type !== 'damage' || this.hasSelectedFiles) {
      return true;
    }
    // eslint-disable-next-line no-alert
    return window.confirm(
      this.$t('pretension_damage_without_files_confirm') as string,
    );
  }

  prepareBody(): CreatePretensionData {
    return {
      dateFrom: this.formData.date ? this.formData.date[0] : '',
      dateTo: this.formData.date ? this.formData.date[1] : '',
      platformId: String(this.formData.platform?.id),
      supplierId: String(this.formData.supplier?.id),
      pretensionType: this.formData.type,
      expensesDescription: this.formData.text,
      justification: '',
      clients: this.formData.cashAccounts.map((item) => ({
        clientId: String(item.client?.id),
        // C1: внутренний клиент без ERP-кода — честный null вместо строки "null"/"" (иначе assemble 400).
        sapId: item.client?.erp_id ? String(item.client.erp_id) : null,
        costCenterId: String(item.costCenter?.id),
        costCenterName: String(item.costCenter?.name),
        sum: parseAmount(item.amount),
      })),
      // КРИТИЧНО: strip hash — assemble сохраняет вложения динамическим INSERT по ключам
      // (saveAttachmentIdempotent), а колонки hash в pretension_documents нет. hash остаётся
      // только в draft-пути (draft_payload).
      attachments: this.formData.attachments.map((a) => ({
        bucket: a.bucket,
        objectName: a.objectName,
        type: a.type,
      })),
      // §3.5: whitelist — добавляем ЯВНО, иначе поле молча теряется. Номер, период и сумму
      // листа не шлём (10833): их берёт из базы листов сам сервис претензий — и при отправке,
      // и в предпросмотре, так что сбой формы не уведёт в документ чужие цифры.
      // Без листов уходит [], а не пропуск ключа: процесс jBPM разбирает его как массив.
      accountingSheets: this.formData.accountingSheets.map((s) => ({
        sheetId: Number(s.sheetId),
      })),
      // CP-S1 §2/§3.5: whitelist — добавляем ЯВНО, иначе поле молча теряется. Item строго {number}.
      // trim — страховка §2 (компонент триммит сам; ловит рукотворные/легаси draft-значения).
      contractParagraphs: this.formData.contractParagraphs.map((p) => ({
        number: String(p.number).trim(),
      })),
    };
  }

  /**
   * Заливает в S3 ещё не загруженные вложения и резолвится по завершении.
   * FileLoader в режиме uploadEventEmitter грузит файлы ТОЛЬКО по событию 'upload'
   * (FileLoader.vue: on('upload') → loadAll → callback). До этого formData.attachments пуст,
   * поэтому save/preview обязаны сперва дождаться загрузки, иначе вложения теряются (FML-ltpt.8).
   * После резолва formData.attachments и uploadFilesDone актуальны (через @change → filesChanged).
   */
  private ensureFilesUploaded(): Promise<void> {
    return new Promise((resolve) => {
      if (this.uploadFiles.listenerCount('upload') === 0) {
        resolve();
        return;
      }
      this.uploadFiles.emit('upload', () => resolve());
    });
  }

  async onSaveDraft(): Promise<void> {
    if (!this.canSaveDraft) {
      this.$bus.$emit('notification', 'Для черновика укажите платформу, поставщика и тип', 'error');
      return;
    }
    // Полного $v-гейта у черновика нет, поэтому дубль пары проверяем явно: иначе задвоенный
    // черновик доживёт до отправки.
    if (!this.ensureNoDuplicateCashAccounts()) {
      return;
    }
    this.isSavingDraft = true;
    try {
      await this.ensureFilesUploaded();
      if (!this.uploadFilesDone) {
        this.$bus.$emit('notification', 'Не все файлы загружены, повторите', 'error');
        return;
      }
      const body = this.buildSaveDraftData();
      const response = this.isEdit && this.draftId !== null
        ? await PretensionController.updateDraft(this.draftId, body, this.draftUpdatedAt || '')
        : await PretensionController.saveDraft(body);

      if (response.code === 409 && this.isEdit && this.draftId !== null) {
        await this.handleDraftConflict(this.draftId);
        return;
      }
      const [error, result] = response.result;
      // PHP envelope: create → {id:number,...}, edit → {updatedAt:string}. Если роут не дошёл
      // до PHP (мисроут → SPA HTML, 200), сюда прилетит строка/мусор — это НЕ успех.
      const validEnvelope = this.isValidDraftEnvelope(error, result, this.isEdit ? 'update' : 'create');
      if (!validEnvelope) {
        this.$bus.$emit('notification', `Не удалось сохранить черновик - ${error || 'неожиданный ответ сервера'}`, 'error');
        return;
      }
      this.$bus.$emit('notification', 'Черновик сохранён', 'success');
      this.$emit('drafts-changed');
      // bug 1: закрываем диалог после успешного сохранения (onModalStateChange сбросит форму/режим).
      this.closeModal();
    } catch (error) {
      this.$bus.$emit('notification', `Не удалось сохранить черновик - ${error}`, 'error');
    } finally {
      this.isSavingDraft = false;
    }
  }

  private async refetchDraft(id: number): Promise<void> {
    const resp = await PretensionController.getDraft(id);
    const [error, fresh] = resp.result;
    if (!error && fresh) {
      this.applyDraftEnvelope(fresh as Draft);
      return;
    }
    // Refresh failed (draft deleted by colleague / network) — ETag stays stale, next save will
    // 409 again. Tell the user instead of silently swallowing it.
    this.$bus.$emit('notification', 'Не удалось обновить черновик, закройте и откройте его заново', 'warning');
  }

  async onPreview(): Promise<void> {
    this.$v.$touch();
    if (this.$v.$invalid || this.$v.$error) {
      this.$bus.$emit('notification', 'Не все поля заполнены корректно', 'error');
      return;
    }
    // Вкладку открываем СИНХРОННО (в обработчике клика) — иначе popup-блокер срежет window.open
    // после await. Сразу рисуем спиннер (генерация PDF идёт несколько секунд), URL выставим,
    // когда придёт файл (просмотр во встроенном браузерном PDF-вьювере, без кастомного диалога).
    const previewTab = openLoadingTab();
    this.isPreviewLoading = true;
    this.isPreviewError = false;
    try {
      await this.ensureFilesUploaded();
      if (!this.uploadFilesDone) {
        showTabError(previewTab, 'Не все файлы загружены');
        this.isPreviewError = true;
        this.$bus.$emit('notification', 'Не все файлы загружены, повторите', 'error');
        return;
      }
      const response = await PretensionController.previewPdf(this.prepareBody());
      const [error, blob] = response.result;
      const pdf = blob as Blob | null;
      // На ошибке обогащения/Talend приходит JSON, а не PDF — это не успех (R3: тост + error-state).
      if (error || !pdf || (pdf.type || '').toLowerCase().includes('json')) {
        showTabError(previewTab, 'Не удалось построить предпросмотр');
        this.isPreviewError = true;
        this.$bus.$emit('notification', `Не удалось построить предпросмотр - ${error || 'неожиданный ответ сервера'}`, 'error');
        return;
      }
      const url = URL.createObjectURL(pdf);
      if (previewTab) {
        previewTab.location.href = url;
      } else {
        window.open(url, '_blank', 'noopener');
      }
    } catch (error) {
      showTabError(previewTab, 'Не удалось построить предпросмотр');
      this.isPreviewError = true;
      this.$bus.$emit('notification', `Не удалось построить предпросмотр - ${error}`, 'error');
    } finally {
      this.isPreviewLoading = false;
    }
  }

  onRetryPreview(): void {
    this.onPreview();
  }

  async onDeleteDraft(): Promise<void> {
    if (!this.isEdit || this.draftId === null) return;
    const message = this.isColleagueDraft
      ? `Удалить черновик коллеги ${this.draftCreatedByEmail}?`
      : 'Удалить черновик?';
    // eslint-disable-next-line no-alert
    if (!window.confirm(message)) return;
    this.isDeletingDraft = true;
    try {
      const resp = await PretensionController.deleteDraft(this.draftId, this.draftUpdatedAt || '');
      if (resp.code === 409) {
        this.$bus.$emit('notification', 'Запись была изменена коллегой, черновик перезагружен', 'warning');
        await this.refetchDraft(this.draftId);
        return;
      }
      if (resp.result[0]) {
        this.$bus.$emit('notification', `Не удалось удалить черновик - ${resp.result[0]}`, 'error');
        return;
      }
      this.$bus.$emit('notification', 'Черновик удалён', 'success');
      this.closeModal();
      this.$emit('drafts-changed');
    } finally {
      this.isDeletingDraft = false;
    }
  }

  async submitCreate(): Promise<void> {
    if (!this.ensureNoDuplicateCashAccounts()) {
      return;
    }
    try {
      this.isSendingCreatingRequest = true;
      const data = this.prepareBody();
      if (this.isEdit && this.draftId !== null) {
        // «Отправить из черновика» (Решение 4): сперва синхронизируем draft_payload с живой формой
        // (updateDraft), затем промоутим существующую draft-строку (draft→created). Зеркально
        // fresh-create (ниже), который первым шагом saveDraft. Без этого круг problem→draft
        // гидрируется из устаревшего payload и теряет несохранённые правки (напр. 3-го клиента).
        // Файлы уже загружены onSubmit (emit 'upload' → submitCreate), как и в fresh-create ветке —
        // отдельный ensureFilesUploaded здесь не нужен, formData.attachments актуальны.
        const updateResp = await PretensionController.updateDraft(
          this.draftId, this.buildSaveDraftData(), this.draftUpdatedAt || '',
        );
        if (updateResp.code === 409) {
          await this.handleDraftConflict(this.draftId);
          return;
        }
        const [updateError, updateResult] = updateResp.result;
        if (!this.isValidDraftEnvelope(updateError, updateResult, 'update')) {
          const reason = updateError || 'неожиданный ответ сервера';
          this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${reason}`, 'error');
          return;
        }
        this.draftUpdatedAt = (updateResult as { updatedAt: string }).updatedAt;
        data.pretensionDraftId = this.draftId;
      } else {
        // Fresh create (Strategy F): сперва сохраняем черновик (buildSaveDraftData пишет
        // re-hydratable draft_payload), затем промоутим его — create уходит в ту же ветку
        // assemble.promote. Иначе draft_payload=NULL и возврат problem→draft даёт пустую форму.
        const draftResp = await PretensionController.saveDraft(this.buildSaveDraftData());
        const [draftError, draftResult] = draftResp.result;
        if (!this.isValidDraftEnvelope(draftError, draftResult, 'create')) {
          const reason = draftError || 'неожиданный ответ сервера';
          this.$bus.$emit('notification', `Возникла ошибка при выполнении операции, попробуйте позже - ${reason}`, 'error');
          return;
        }
        data.pretensionDraftId = (draftResult as { id: number }).id;
      }
      const response = await PretensionController.create(data);
      const [error] = response.result;
      if (error) {
        this.$bus.$emit('notification', `Возникла ошибка при выполнении операции: ${describeOperationError(error)}`, 'error');
        return;
      }
      this.formData = cloneDeep(this.defaultFormData);
      this.selectedFileNames = [];
      this.resetToCreate();
      this.$v.$reset();
      this.$bus.$emit('notification', 'Операция выполнена', 'success');
      this.closeModal();
      this.$emit('after-creation');
      this.$emit('drafts-changed');
    } catch (error) {
      this.$bus.$emit('notification', `Возникла ошибка при выполнении операции: ${describeOperationError(error)}`, 'error');
    } finally {
      this.isSendingCreatingRequest = false;
    }
  }

  async onSubmit() {
    const uploadFilesCallback = async () => {
      if (!this.uploadFilesDone) {
        this.$bus.$emit('notification', 'Не все файлы загружены', 'error');
        return;
      }
      await this.submitCreate();
    };

    // Лист, чей ID ввели перед самым нажатием, должен успеть загрузиться и пройти сверку.
    await this.loadSheetsOfRows();
    this.$v.$touch();
    // Раньше общего гейта: «Не все поля заполнены корректно» не объясняет, какая пара задвоена.
    if (!this.ensureNoDuplicateCashAccounts()) {
      return;
    }
    if (this.$v.$invalid || this.$v.$error || this.hasSheetRowErrors) {
      this.$bus.$emit('notification', 'Не все поля заполнены корректно', 'error');
      return;
    }
    if (this.hasNonPdfAttachment) {
      this.$bus.$emit('notification', this.$t('pretension_non_pdf_blocked') as string, 'error');
      return;
    }
    if (this.oversizeAttachmentsMessage) {
      this.$bus.$emit('notification', this.oversizeAttachmentsMessage, 'error');
      return;
    }
    const confirmed = await this.confirmDamageWithoutFiles();
    if (!confirmed) {
      return;
    }
    this.uploadFiles.emit('upload', uploadFilesCallback);
  }

  clearSelectedClients() {
    this.formData.cashAccounts.forEach((item) => {
      item.client = this.defaultFormData.cashAccounts[0].client;
    });
  }

  @Watch('isModalVisible')
  onModalStateChange(value: boolean) {
    if (!value) {
      this.formData = cloneDeep(this.defaultFormData);
      this.selectedFileNames = [];
      this.$v.$reset();
      // Clean slate on close: drop edit-mode state too, otherwise mode/draftId/draftUpdatedAt
      // leak into the next open (e.g. after in-modal delete closeModal, or external
      // toggling of the shared entity.isModalVisible by another modal on the page).
      this.resetToCreate();
      this.isPreviewError = false;
    }
  }

  @Watch('formData.platform', {
    immediate: true,
  })
  formDataPlatformChange() {
    // При гидрации черновика (applyDraftEnvelope переустанавливает formData) этот вотчер
    // срабатывает на смену platform и НЕ должен затирать восстановленные supplier/clients —
    // только подгрузить справочники для дропдаунов. Флаг снимается в $nextTick после flush.
    if (!this.isHydratingDraft) {
      this.formData.supplier = this.defaultFormData.supplier;
      this.clearSelectedClients();
    }
    const platformId = this.formData?.platform?.id || '';
    if (!platformId) {
      // Без платформы дропдауны поставщиков/клиентов должны быть пусты. loadDataByLike при пустом
      // значении выходит рано и НЕ обнуляет списки — иначе остаются устаревшие (от прошлого
      // черновика/выбора), и клиента можно выбрать без платформы. Чистим явно (как changePlatform
      // на странице-фильтре сбрасывает selectedSuppliers).
      this.suppliers = [];
      this.clients = [];
      return;
    }
    this.loadDataByLike('suppliers', 'Supplier', 'PlantsHR', platformId, 'cache-first', {
      maxDepth: 1,
    });
    this.loadDataByLike('clients', 'Client', 'Plants', platformId, 'cache-first', {
      maxDepth: 1,
    });
  }
}
